export default {"src":"/_next/static/media/pura.49e709b1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};